import React from "react";
import { useNavigate } from "react-router-dom";

export function CategoryRail({ categories = [] }) {
  const nav = useNavigate();
  return (
    <div className="flex gap-4 overflow-x-auto hide-scrollbar snap-x-m px-4 pb-1" data-testid="category-rail">
      {categories.map((c) => (
        <button key={c.id} onClick={() => nav(`/search?cat=${encodeURIComponent(c.name)}`)} className="flex flex-col items-center gap-1.5 snap-start-m tap" data-testid={`category-chip-${c.slug}`}>
          <div className="w-16 h-16 rounded-full overflow-hidden ring-2 ring-coral-light shadow-sm">
            <img src={c.image} alt={c.name} loading="lazy" className="w-full h-full object-cover" />
          </div>
          <span className="text-[11px] font-semibold text-ink whitespace-nowrap">{c.name}</span>
        </button>
      ))}
    </div>
  );
}
